import React from 'react';
import { Route } from 'react-router-dom';

import DenominacoesFicha from '../../ProdutosDAF/DenominacoesGenericas/DenominacoesFicha';
import DenominacoesIndex from '../../ProdutosDAF/DenominacoesGenericas/DenominacoesIndex';
import DenominacoesVinculos from '../../ProdutosDAF/DenominacoesGenericas/DenominacoesVinculos';
import KitsFicha from '../../ProdutosDAF/Kits/KitsFicha';
import KitsIndex from '../../ProdutosDAF/Kits/KitsIndex';
import KitsVinculos from '../../ProdutosDAF/Kits/KitsVinculos';
import MedsusIndex from '../../ProdutosDAF/MedSUS';
import { MedsusDiretrizClinica } from '../../ProdutosDAF/MedSUS/components/DiretrizClinica';
import PdpFicha from '../../ProdutosDAF/PDP/PdpFicha';
import PdpIndex from '../../ProdutosDAF/PDP/PdpIndex';
import ProdutosVinculos from '../../ProdutosDAF/Produtos/ProdutosVinculos';
import ProdutosDafListagem from '../../ProdutosDAF/Produtos/listagem';
import ProdutosDafDadosGerais from '../../ProdutosDAF/Produtos/produtosDadosGerais/produtosDafDadosGerais';

const ProdutosDAFRoutes = () => {
  return (
    <>
      {/* Produtos Farmacêuticos */}
      <Route path="produtosdaf/produtos" element={<ProdutosDafListagem />} />
      <Route
        path="produtosdaf/produtos/dadosgerais"
        element={<ProdutosDafDadosGerais />}
      />
      <Route
        path="produtosdaf/produtos/:id/dadosgerais"
        element={<ProdutosDafDadosGerais />}
      />
      <Route
        path="produtosdaf/produtos/:id/vinculos"
        element={<ProdutosVinculos />}
      />

      {/* Denominações Genéricas */}
      <Route path="produtosdaf/denominacoes" element={<DenominacoesIndex />} />
      <Route
        path="produtosdaf/denominacoes/dadosgerais"
        element={<DenominacoesFicha />}
      />
      <Route
        path="produtosdaf/denominacoes/:id/dadosgerais"
        element={<DenominacoesFicha />}
      />
      <Route
        path="produtosdaf/denominacoes/:id/vinculos"
        element={<DenominacoesVinculos />}
      />

      {/* Kits de Produtos Farmacêuticos */}
      <Route path="produtosdaf/kits" element={<KitsIndex />} />
      <Route path="produtosdaf/kits/dadosgerais" element={<KitsFicha />} />
      <Route path="produtosdaf/kits/:id/dadosgerais" element={<KitsFicha />} />
      <Route path="produtosdaf/kits/:id/vinculos" element={<KitsVinculos />} />

      {/* PDPs */}
      <Route path="produtosdaf/pdps" element={<PdpIndex />} />
      <Route path="produtosdaf/pdps/ficha/dadosgerais" element={<PdpFicha />} />
      <Route
        path="produtosdaf/pdps/ficha/:id/dadosgerais"
        element={<PdpFicha />}
      />

      {/* MedSUS */}
      <Route path="produtosdaf/medsus" element={<MedsusIndex />} />
      <Route
        path="produtosdaf/medsus/dadosgerais"
        element={<MedsusDiretrizClinica />}
      />
      <Route
        path="produtosdaf/medsus/:id/dadosgerais"
        element={<MedsusDiretrizClinica />}
      />
    </>
  );
};

export default ProdutosDAFRoutes;
